(function () {
  const id = document.currentScript.getAttribute("data-id");
  const autoplay = document.currentScript.getAttribute(
    "data-carousel-autoplay"
  );
  const dots_arrows_color = document.currentScript.getAttribute(
    "data-dots-arrows-color"
  );
  const section_block_gap = document.currentScript.getAttribute(
    "data-section-block-gap"
  );
  const wrap_around = document.currentScript.getAttribute(
    "data-carousel-wrap-around"
  );
  const runCarousels = ({
    autoplay,
    dots_arrows_color,
    section_block_gap,
    wrap_around,
  }) => {
    const selectors = {
      carousel: document.querySelector(
        `section.${id} .js-ts0app-carousel-3__carousel`
      ),
      cells: document.querySelectorAll(
        `.${id} .js-ts0app-carousel-3__carousel .js-ts0app-carousel-3-item`
      ),
    };

    new Flickity(selectors.carousel, {
      // options
      cellAlign: "left",
      contain: true,
      imagesLoaded: true,
      autoPlay: autoplay * 1000,
      wrapAround: wrap_around === "true",
    });

    const dots = document.querySelectorAll(
      `.${id} .js-ts0app-carousel-3__carousel .flickity-page-dots .dot`
    );
    const arrows = document.querySelectorAll(
      `.${id} .js-ts0app-carousel-3__carousel .flickity-button-icon`
    );
    const dotsUl = document.querySelector(
      `.${id} .js-ts0app-carousel-3__carousel .flickity-page-dots`
    );
    const next_button = document.querySelector(`.${id} .flickity-button.next`);
    dots.forEach((dot) => {
      dot.style.background = dots_arrows_color;
    });
    arrows.forEach((arrow) => {
      arrow.style.fill = dots_arrows_color;
    });
    const newEl = document.createElement("li");
    newEl.classList.add(
      `ts0app__pr-${section_block_gap}`,
      "dot",
      "ts0app__flickity-dot-placeholder"
    );
    dotsUl.appendChild(newEl);
    next_button.classList.add(`ts0app__mr-${section_block_gap}`);
  };

  runCarousels({ autoplay, dots_arrows_color, section_block_gap, wrap_around });

  // handle theme editor changes
  document.addEventListener("shopify:section:load", (e) => {
    const sectionId = e.detail?.sectionId;
    if (sectionId === id) {
      const script = e.target.querySelector(`script[data-id='${sectionId}']`);
      const autoplay = script.getAttribute("data-carousel-autoplay");
      const dots_arrows_color = script.getAttribute("data-dots-arrows-color");
      const section_block_gap = script.getAttribute("data-section-block-gap");
      const wrap_around = script.getAttribute("data-carousel-wrap-around");
      runCarousels({
        autoplay,
        dots_arrows_color,
        section_block_gap,
        wrap_around,
      });
    }
  });
})();
